//#region src/utils/time.ts
var e = 1, t = 1e3, n = 6e4, r = n * 60, i = r * 24, a = i * 7, o = "en-GB", s = [
	{
		label: "m ago",
		value: n
	},
	{
		label: "h ago",
		value: r
	},
	{ value: i }
], c = (e) => {
	let t = /* @__PURE__ */ new Date(), n = new Date(e), r = Math.abs(t.valueOf() - n.valueOf());
	for (let e = 0; e < s.length - 1; e++) if (r < s[e + 1].value) return `${Math.max(Math.floor(r / s[e].value), 1)}${s[e].label}`;
	return l(e, t.getFullYear() !== n.getFullYear());
}, l = (e, t = !0, n = !0, r) => {
	let i = typeof e == "string" ? new Date(e) : e, a = i.toLocaleDateString(o, {
		day: "numeric",
		month: "short",
		year: t ? "numeric" : void 0,
		timeZone: r
	});
	return n ? `${a} ${i.toLocaleTimeString(o, {
		hour: "2-digit",
		minute: "2-digit",
		timeZone: r
	})}` : a;
}, u = (e, t) => (e.valueOf() - t.valueOf()) / i, d = (e) => {
	let t, n = e.getDate();
	if (n > 3 && n < 21) t = "th";
	else switch (n % 10) {
		case 1:
			t = "st";
			break;
		case 2:
			t = "nd";
			break;
		case 3:
			t = "rd";
			break;
		default:
			t = "th";
			break;
	}
	return `${n}${t} ${e.toLocaleDateString(o, { month: "long" })}`;
};
//#endregion
export { i as day, l as formatDate, d as formatDateOrdinalDay, u as getDaysDiff, r as hour, o as locale, e as millisecond, n as minute, c as relatedDate, t as second, a as week };
